import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {IconsModule} from 'src/app/icons/icons.module';
import {SearchBoxComponent} from './search-box.component';


@NgModule({
  declarations: [
    SearchBoxComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule
  ],
  exports: [
    SearchBoxComponent
  ]
})
export class SearchBoxModule {
}
